import clsx from "clsx";
import React, { useEffect, useMemo, useRef, useState } from "react";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { format } from "date-fns";
import { get } from "lodash";
import { FormProvider, useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";

import FileLoader from "~/components/FileLoader";
import useGetDealer from "~/components/Forms/DealerPassportForm2/hook/useGetDealer";
import useGetDocs from "~/components/Forms/DealerPassportForm2/hook/useGetDocs";
import useGetRequsites from "~/components/Forms/DealerPassportForm2/hook/useGetRequsites";
import useUpdateDealer from "~/components/Forms/DealerPassportForm2/hook/useUpdateDealer";
import useUpdateDocs from "~/components/Forms/DealerPassportForm2/hook/useUpdateDocs";
import Accordion from "~/components/Forms/DealerPassportForm2/UI/Accordion";
import DynamicFormField from "~/components/Forms/DealerPassportForm2/UI/DynamicFormField";
import Table from "~/components/Table";
import Button from "~/shared/ui/Fields/Button";
import Input from "~/shared/ui/Fields/Input";
import Modal from "~/shared/ui/Fields/Modal";
import {
  getDealerBankDetails,
  getDealerRequisites,
} from "~/components/Forms/DealerPassportForm2/Docs/options";
import { DEALER_PASSPORT_PROJECT_FILE } from "~/components/Forms/DealerPassportForm2/options";
import { validateInn } from "~/components/Forms/DealerPassportForm2/requests/dadata";
import { FieldConfig } from "~/components/Forms/DealerPassportForm2/types";
import { useGetLocationData, useSetLocationData } from "~/hooks/locationData";
import {
  ContractType,
  useDownloadContractLazyQuery,
  // useGetContractsQuery,
  useGetDealerQuery,
  useGetProjectDocumentationsDealerQuery,
  useSetProjectDocumentationDealerMutation,
} from "~/schemas/generated/graphql";
import { usePermissions } from "~/shared/context/PermissionContext";
import { useNotify } from "~/shared/hooks/useNotify";
import { dateFormat } from "~/shared/lib/DateFormat/dateFormat";

import s from "./Docs.less";

interface DocsProps {
  DealerId: string;
  idArchive?: string;
  allDisabled: boolean;
}

const Docs = ({ DealerId, idArchive, allDisabled }: DocsProps) => {
  const { t } = useTranslation();
  const isRu = localStorage.getItem("language") === "ru";
  const isAdd = DealerId === "add";
  const setData = useSetLocationData();
  const { openModal, event } = useGetLocationData();
  const [switcher, setSwitcher] = useState(false);
  const { notifyReport, notifyError, notifySuccess } = useNotify();
  const { hasPermission, loading: loadingPermissions } = usePermissions();
  const availableToEdit = hasPermission("dealer.updateDocs");
  const dealerRequisites = getDealerRequisites(t, "");
  const dealerBankDetails = getDealerBankDetails(t, "");

  const { data: dataDealer, isFetching: isLoadingDealer } =
    useGetDocs(DealerId);
  const { mutate: updateDocs, isLoading: isUpdating } = useUpdateDocs();
  const { data: dataHash } = useGetRequsites(DealerId, switcher);

  console.log(dataDealer, "dataDealer");

  const getHash = () => {
    setSwitcher(true);
  };

  useEffect(() => {
    if (dataHash) {
      notifyReport(dataHash.fileHash);
      setSwitcher(false);
    }
  }, [dataHash]);

  const formResolver = yup.object().shape({
    kpp: yup.string().nullable().required(t("validation.required")),
    ogrn: yup.string().nullable().required(t("validation.required")),
    birCode: yup.string().nullable().required(t("validation.required")),
    bankName: yup.string().nullable().required(t("validation.required")),
    egrSeries: yup.string().nullable().required(t("validation.required")),
    bik: yup.string().nullable().required(t("validation.required")),
    correspondentAccount: yup
      .string()
      .nullable()
      .required(t("validation.required")),
    regionCode: yup.string().nullable().required(t("validation.required")),
    inn: yup
      .string()
      .nullable()
      .required(t("validation.invalid_inn"))
      .test("", "Некорректный инн", async (value) => {
        if (!value) {
          return true;
        }
        try {
          const isValid = await validateInn(value);
          return isValid;
        } catch (e) {
          return false;
        }
      }),
  });

  let dataNew;
  let refetchNew;
  let loadingNew;

  if (!isAdd) {
    const { data, refetch, loading } = useGetDealerQuery({
      variables: {
        DealerId,
        ArchivePeriodId: idArchive,
      },
      fetchPolicy: "no-cache",
    });
    dataNew = data;
    refetchNew = refetch;
    loadingNew = loading;
  }

  const openModProject = () => {
    setData("openModal", "Project");
  };
  const addContract = (event) => {
    setData("openModal", "addContract", "event", event);
  };
  const handleCloseModal = () => {
    setData("openModal", "");
  };
  const GetContractsAdd = [];
  const isContractLoading = false;
  let refetchCustom;
  const shemaFormRequared = yup.object().shape({
    projectName: yup.string().nullable().required(t("validation.required")),
    projectFile: yup.string().nullable().required(t("validation.required")),
  });

  const projectForm = useForm({
    resolver: openModal === "Project" && yupResolver(shemaFormRequared),
  });

  const projectFileWatch = projectForm.watch("projectFile");

  if (!isAdd) {
    // const loger = useGetContractsQuery({
    //   variables: {
    //     DealerId,
    //     type: ContractType["Custom"],
    //   },
    // });
    // const gporf = get(loger, "data.DealerRegistryGetter.getContracts", []);
    //
    // GetContractsAdd.push(...gporf);
    // isContractLoading = loger.loading;
    // refetchCustom = loger.refetch;
  }
  const [queryReportContract] = useDownloadContractLazyQuery({
    onCompleted(data) {
      const hash = get(data, "DealerRegistryGetter.downloadContract.fileHash");
      hash && notifyReport(hash);
    },
    fetchPolicy: "no-cache",
  });

  const projectData = useGetProjectDocumentationsDealerQuery({
    variables: { DealerId },
    skip: isAdd || !hasPermission("dealergraph.projectDocumentation.get"),
  });

  const itemProject = get(
    projectData,
    "data.DealerGetter.getProjectDocumentationsDealer.items",
    []
  ).map(({ name, status, createdAt, File }) => {
    return {
      name,
      status: t(`project.${status}`),
      createdAt: format(new Date(createdAt), "dd.MM.yyyy"),
      File,
    };
  });

  const [ProjectDocumentationDealerMutation] =
    useSetProjectDocumentationDealerMutation({
      onCompleted() {
        refetchNew?.();
        if (!isAdd && hasPermission("dealergraph.projectDocumentation.set")) {
          projectData && projectData.refetch();
        }
        projectForm.setValue("projectFile", "");
        projectForm.setValue("projectName", "");
      },
      onError({ graphQLErrors }) {
        notifyError(graphQLErrors[0].message);
      },
    });
  const addProject = (data) => {
    ProjectDocumentationDealerMutation({
      variables: {
        FileId: data.projectFile,
        DealerId,
        name: data.projectName,
      },
    });
  };
  const fileFields = useMemo(
    () => [
      {
        name: "projectDocumentation",
        label: t("ui.download_title_project_documentation"),
        titleDownload: t("ui.download_title_project_documentation"),
        download: dataDealer?.projectDocumentation,
      },
      {
        name: "contract",
        label: t("ui.download_title_contract"),
        titleDownload: t("ui.download_title_contract"),
        download: dataDealer?.contract,
      },
    ],
    [dataDealer, t]
  );

  const normalizeDataDealer = (dataDealer: any) => {
    const egrDate =
      dateFormat(dataDealer?.requsites?.egrDate, { type: "date" }) ?? "";
    return {
      egrDate,
      legalAddress: dataDealer?.requsites?.legalAddress ?? "",
      postalAddress: dataDealer?.requsites?.postalAddress ?? "",
      legalDealerName: dataDealer?.requsites?.legalDealerName ?? "",
      tradeDealerName: dataDealer?.requsites?.tradeDealerName ?? "",
      kpp: dataDealer?.requsites?.kpp ?? "",
      ogrn: dataDealer?.requsites?.ogrn ?? "",
      inn: dataDealer?.requsites?.inn ?? "",
      birCode: dataDealer?.requsites?.birCode ?? "",
      egrNumber: dataDealer?.requsites?.egrNumber ?? "",
      egrSeries: dataDealer?.requsites?.egrSeries ?? "",
      code: dataDealer?.requsites?.code ?? "",
      bankName: dataDealer?.bank?.bankName ?? "",
      bik: dataDealer?.bank?.bik ?? "",
      correspondentAccount: dataDealer?.bank?.correspondentAccount ?? "",
      settlementAccount: dataDealer?.bank?.settlementAccount ?? "",
      regionCode: dataDealer?.bank?.regionCode ?? "",
      owner: dataDealer?.owner?.id ?? null,
      boss: dataDealer?.boss?.id ?? null,
      accountant: dataDealer?.accountant?.id ?? null,
      ladaResponsible: dataDealer?.ladaResponsible?.id ?? null,
      projectDocumentation: dataDealer?.projectDocumentation?.id ?? null,
      contract: dataDealer?.contract?.id ?? null,
    };
  };

  const method = useForm({
    defaultValues: {
      legalAddress: "",
      postalAddress: "",
      legalDealerName: "",
      tradeDealerName: "",
      kpp: "",
      ogrn: "",
      inn: "",
      birCode: "",
      egrNumber: "",
      egrSeries: "",
      egrDate: "",
      bankName: "",
      bik: "",
      correspondentAccount: "",
      settlementAccount: "",
      regionCode: "",
      owner: null,
      boss: null,
      accountant: null,
      ladaResponsible: null,
      projectDocumentation: null,
      contract: null,
    },
    resolver: yupResolver(formResolver),
  });

  const prevDataDealerRef = useRef<string | null>(null);

  useEffect(() => {
    if (dataDealer) {
      const serializedData = JSON.stringify(dataDealer);
      if (serializedData !== prevDataDealerRef.current) {
        const formValues = normalizeDataDealer(dataDealer);
        method.reset(formValues);
        prevDataDealerRef.current = serializedData;
      }
    }
  }, [dataDealer, method]);

  const onSubmit = (data: any) => {
    const formattedData = {
      id: parseInt(DealerId, 10),
      dealerName: dataDealer?.dealerName || "",
      requsites: {
        legalAddress:
          data.legalAddress || dataDealer?.requsites?.legalAddress || "",
        postalAddress:
          data.postalAddress || dataDealer?.requsites?.postalAddress || "",
        tradeDealerName:
          data.tradeDealerName || dataDealer?.requsites?.tradeDealerName || "",
        legalDealerName:
          data.legalDealerName || dataDealer?.requsites?.legalDealerName || "",
        kpp: data.kpp || dataDealer?.requsites?.kpp || "",
        ogrn: data.ogrn || dataDealer?.requsites?.ogrn || "",
        inn: data.inn || dataDealer?.requsites?.inn || "",
        birCode: data.birCode || dataDealer?.requsites?.birCode || "",
      },
      bank: {
        bankName: data.bankName || dataDealer?.bank?.bankName || "",
        bik: data.bik || dataDealer?.bank?.bik || "",
        correspondentAccount:
          data.correspondentAccount ||
          dataDealer?.bank?.correspondentAccount ||
          "",
        settlementAccount:
          data.settlementAccount || dataDealer?.bank?.settlementAccount || "",
        regionCode: data.regionCode || dataDealer?.bank?.regionCode || "",
      },
      docs: {
        owner: data.owner
          ? { id: Number(data.owner) }
          : dataDealer?.owner?.id
          ? { id: Number(dataDealer.owner.id) }
          : { id: 0 },
        boss: data.boss
          ? { id: Number(data.boss) }
          : dataDealer?.boss?.id
          ? { id: Number(dataDealer.boss.id) }
          : { id: 0 },
        accountant: data.accountant
          ? { id: Number(data.accountant) }
          : dataDealer?.accountant?.id
          ? { id: Number(dataDealer.accountant.id) }
          : { id: 0 },
        ladaResponsible: data.ladaResponsible
          ? { id: Number(data.ladaResponsible) }
          : dataDealer?.ladaResponsible?.id
          ? { id: Number(dataDealer.ladaResponsible.id) }
          : { id: 0 },
        projectDocumentation: data.projectDocumentation
          ? { id: Number(data.projectDocumentation) }
          : dataDealer?.projectDocumentation?.id
          ? { id: Number(dataDealer.projectDocumentation.id) }
          : { id: 0 },
        contract: data.contract
          ? { id: Number(data.contract) }
          : dataDealer?.contract?.id
          ? { id: Number(dataDealer.contract.id) }
          : { id: 0 },
      },
    };
    fileFields.forEach((field) => {
      if (data[field.name] === null) {
        if (formattedData.docs && field.name in formattedData.docs) {
          formattedData.docs[field.name] = { id: 0 };
        }
      }
    });
    updateDocs(
      { dealerId: DealerId, data: formattedData },
      {
        onSuccess: () => {
          notifySuccess(t("common.сhange_was_successful"));
          console.log("Docs updated successfully");
        },
        onError: (error) => {
          console.error("Error updating docs:", error);
        },
      }
    );
  };

  const deleteFileByName = (fileField: string, idField: string) => {
    const formData = method.getValues();
    const updatedData = { ...formData, [fileField]: null, [idField]: null };
    method.reset(updatedData);
    method.register(idField);
  };

  const pnInfoItems = useMemo(() => {
    if (!dataDealer?.pnInfo) return [];
    return dataDealer.pnInfo.split("\r\n").filter((item) => item.trim() !== "");
  }, [dataDealer?.pnInfo]);

  if (isLoadingDealer) {
    return <div>Loading...</div>;
  }

  return (
    <div>
      <FormProvider {...method}>
        <form
          onSubmit={method.handleSubmit(onSubmit)}
          className={clsx("dynamic-form")}
        >
          <div className={s.wrapper}>
            <div className={s.wrapperItem}>
              <div className={s.wrapperBase}>
                <div className={s.title}>
                  <div>Реквизиты</div>
                  {hasPermission("dealer.generateRequsites") && (
                    <Button
                      txtBtn={"Скачать реквизиты"}
                      customClassName={s.butMini}
                      onClick={getHash}
                    />
                  )}
                </div>
                <div className={s.border}>
                  <div className={s.infoWrapper}>
                    <div className={s.infoLeft}>
                      <div className={s.text}>Реквизиты компании</div>
                      {dataDealer && dataDealer.requsites ? (
                        dealerRequisites.map((field) =>
                          [
                            "legalAddress",
                            "postalAddress",
                            "legalDealerName",
                            "tradeDealerName",
                          ].includes(field.name) ? (
                            <div className={s.wrapText} key={field.name}>
                              <label>{field.label}</label>
                              <div>
                                {dataDealer.requsites[field.name] ??
                                  "Не указано"}
                              </div>
                            </div>
                          ) : (
                            <DynamicFormField
                              key={field.name}
                              {...field}
                              disabled={allDisabled}
                            />
                          )
                        )
                      ) : (
                        <div>Данные загружаются или отсутствуют</div>
                      )}
                    </div>
                    <div className={s.infoRight}>
                      <div className={s.text}>Банковские реквизиты</div>
                      {dataDealer &&
                        dealerBankDetails.map((field) => (
                          <DynamicFormField
                            key={field.name}
                            {...field}
                            disabled={allDisabled}
                          />
                        ))}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className={s.wrapperItem}>
              <div className={s.wrapperBase}>
                <div className={s.title}>
                  <div>Прикрепление документов</div>
                  <div className={s.btnWrapper}>
                    {hasPermission("dealergraph.projectDocumentation.get") && (
                      <Button
                        txtBtn={"Проектная документация"}
                        customClassName={s.butMini}
                        onClick={openModProject}
                      />
                    )}
                    <a
                      className={s.hrefLink}
                      href={"/userfiles/template1.docx"}
                      download
                      target={"_blank"} rel="noreferrer"
                    >
                      <Button
                        txtBtn={"Шаблон перс.данных"}
                        customClassName={s.butMini}
                      />
                    </a>
                  </div>
                </div>
                {fileFields.map((field) => (
                  <div className={s.fileWrap} key={field.name}>
                    <FileLoader
                      name={field.name}
                      withButton
                      isNewStyleScan
                      isNoneUpload={!!idArchive}
                      label={field.label}
                      disabled={!availableToEdit || allDisabled}
                      deleteFile={() =>
                        deleteFileByName(field.download, field.name)
                      }
                      download={field.download}
                      titleDownload={field.titleDownload}
                      control={method.control}
                      setValue={method.setValue}
                    />
                  </div>
                ))}
              </div>
            </div>
            <Accordion title={"Решение дилерской комиссии"}>
              <div className={s.pnInfoContainer}>
                {pnInfoItems.length > 0 ? (
                  pnInfoItems.map((item, index) => (
                    <div key={index} className={s.pnInfoItem}>
                      {item}
                    </div>
                  ))
                ) : (
                  <div>Нет данных</div>
                )}
              </div>
            </Accordion>

            <div className={s.wrapperBTN}>
              {!allDisabled && (
                <Button
                  txtBtn={"Сохранить изменения"}
                  orange
                  isForm
                  customClassName={s.but}
                />
              )}
            </div>
          </div>
        </form>
      </FormProvider>
      <Modal
        isOpen={openModal === "Project"}
        title={"Проектная деятельность"}
        actionClose={handleCloseModal}
      >
        <form
          className={s.formComment}
          onSubmit={projectForm.handleSubmit(addProject)}
        >
          <Table
            customClassName={s.tableProject}
            sortable={false}
            items={itemProject}
            options={DEALER_PASSPORT_PROJECT_FILE}
            type={"project"}
          />

          {(availableToEdit || !allDisabled) &&
            hasPermission("dealergraph.projectDocumentation.set") && (
              <>
                <Input
                  label={"Название документа"}
                  control={projectForm.control}
                  error={projectForm.errors["projectName"]?.message}
                  name={"projectName"}
                />

                <div className={s.wrapperFile}>
                  <FileLoader
                    name={"projectFile"}
                    withText
                    withButton
                    watch={projectFileWatch}
                    error={projectForm.errors["projectFile"]?.message}
                    label={"Загрузите файл"}
                    accept={".pdf"}
                    control={projectForm.control}
                    setValue={projectForm.setValue}
                    customErrorStyle={s.errorsFileLoader}
                  />
                </div>

                <Button
                  txtBtn={t("ui.cancel")}
                  empty
                  onClick={handleCloseModal}
                  customClassName={s.modalBtn}
                />
                {
                  <Button
                    txtBtn={t("ui.save")}
                    isForm
                    customClassName={s.modalBtn}
                  />
                }
              </>
            )}
        </form>
      </Modal>
    </div>
  );
};

export default Docs;
